import { render } from "./Face.vue?vue&type=template&id=e95d3342&scoped=true&ts=true"
import script from "./Face.vue?vue&type=script&lang=ts"
export * from "./Face.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=e95d3342&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95d3342"]])

export default __exports__